module.exports = "\r\n.name {\r\n    width: 10%;\r\n}\r\n\r\n.update {\r\n    width: 15%;\r\n}\r\n\r\n.contents {\r\n    width: 75%;\r\n}"